var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 52.5,
    cy: 52.0332,
    r: 44.5,
    stroke: "#2C6AFF",
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycle);
export default __webpack_public_path__ + "static/media/cycle.30fe8cc8857a3e27f12a955b4dfaaf78.svg";
export { ForwardRef as ReactComponent };